var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExtLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1401_809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5158 7.23684V6.75399L14.1744 7.09541L13.3323 7.93752L13.2737 7.9961V8.07894V11.4474C13.2737 12.2671 12.6092 12.9316 11.7895 12.9316H5.05268C4.23298 12.9316 3.56847 12.2671 3.56847 11.4474V4.71052C3.56847 3.89081 4.23298 3.22631 5.05268 3.22631H8.4211H8.50395L8.56253 3.16773L9.40463 2.32563L9.74605 1.9842H9.26321H4.21058C3.16996 1.9842 2.32637 2.82779 2.32637 3.86841V12.2895C2.32637 13.3301 3.16996 14.1737 4.21058 14.1737H12.6316C13.6722 14.1737 14.5158 13.3301 14.5158 12.2895V7.23684Z",
    fill: "#27AE60",
    stroke: "#27AE60",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 0.5H11.7894L13.3052 2.01579L7.57886 7.74211L8.7578 8.92105L14.4841 3.19474L15.9999 4.71053V0.5Z",
    fill: "#27AE60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1401_809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtLink);
export default __webpack_public_path__ + "static/media/ext-link.acb6569a2c98e5fc0e81c7f59c961b0c.svg";
export { ForwardRef as ReactComponent };